<div class="container-fluid">
  <div class="container py-4">
      <hr>
      <div class="row">
          <!-- Left Form -->
          <div class="col-lg-8">
              <h5>Informations de paiement</h5>
              <p>Lorem ipsum in dolore nan laser detest larum uipsom</p>

              <div class="payment-info">
                  <!-- Payment Method Selection -->
                  <div class="mb-4">
                    <h6 class="fw-light">Méthode paiement:</h6>
                    <div class="d-flex gap-3">
                      <button type="button" class="btn btn-outline-secondary d-flex align-items-center gap-2">
                        <img src="./../../../../../assets/images/payement/mastercard.jpg" alt="Credit/Debit Card" style="width: 24px;"> Credit / Carte Debit
                      </button>
                      <button type="button" class="btn btn-outline-secondary d-flex align-items-center gap-2">
                        <img src="./../../../../../assets/images/payement/momo.png" alt="PayPal" style="width: 24px;"> Paiement Mobile
                      </button>
                      <!-- <button type="button" class="btn btn-outline-primary d-flex align-items-center gap-2">
                        <img src="./../../../../../assets/images/payement/paiement-a-la-livraison.png" alt="Cash on Delivery" style="width: 24px;"> Paiement à la livraison
                      </button> -->
                    </div>
                  </div>

                  <!-- Card Payment Form -->
                  <div class="card-payment-form mt-4">
                    <h6>Payment par carte</h6>
                    <div class="form-group mb-3">
                      <label for="nameOnCard" class="form-label">Nom du détenteur</label>
                      <input type="text" id="nameOnCard" class="form-control" placeholder="Nom complet">
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="cardNumber" class="form-label">Numéro de carte</label>
                        <input type="text" id="cardNumber" class="form-control" placeholder="0000 0000 0000 0000">
                      </div>
                      <div class="col-md-3 mb-3">
                        <label for="expiryDate" class="form-label">Date d'expiration</label>
                        <input type="text" id="expiryDate" class="form-control" placeholder="MM/YY">
                      </div>
                      <div class="col-md-3 mb-3">
                        <label for="cvvCode" class="form-label">CVV Code</label>
                        <input type="text" id="cvvCode" class="form-control" placeholder="Saisir CVV Code">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end" style="gap: 10px;">
                  <a routerLink="/ikena/reservation" class="btn btn-suivant" style="background-color: #161616; color: white;">
                      <i class="fas fa-arrow-left"></i> Retour
                    </a>
                  <a  class="btn btn-suivant" style="background-color: #6B8036; color: white;">
                    Terminer <i class="fas fa-arrow-righ"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bookmark-check-fill" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5m8.854-9.646a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                    </svg></i>
                  </a>

                </div>
          </div>


          <div class="col-lg-4">
              <div class="card checkout-order-summary">
                  <div class="card-body">
                      <div class="p-3 bg-light mb-4">
                          <h5 class="font-size-14 mb-0">Résumé : </h5>
                      </div>
                      <div class="table-responsive">
                          <table class="table table-centered mb-0 table-nowrap">
                              <thead>
                                  <tr>
                                      <th class="border-top-0" style="width: 110px;" scope="col">
                                          Produit</th>
                                      <th class="border-top-0" scope="col">Description</th>
                                      <th class="border-top-0" scope="col">Prix</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr>
                                      <th scope="row"><img src="./../../../../../assets/images/location/tracteur_1.png"
                                              alt="product-img" title="product-img"
                                              class="avatar-md"></th>
                                      <td>
                                          <h5 class="font-size-14 text-truncate"><a
                                                  href="./../details/detail.html"
                                                  class="text-dark">Agrimax 3000</a></h5>
                                          <p class="text-muted mb-0">105 000 x 2</p>
                                      </td>
                                      <td>210 000</td>
                                  </tr>
                                  <tr>
                                      <th scope="row"><img src="./../../../../../assets/images/location/tracteur_1.png"
                                              alt="product-img" title="product-img"
                                              class="avatar-md"></th>
                                      <td>
                                          <h5 class="font-size-14 text-truncate"><a
                                                  href="./../details/detail.html"
                                                  class="text-dark">Half sleeve T-shirt</a></h5>
                                          <p class="text-muted mb-0">105 000 x 2</p>
                                      </td>
                                      <td>210 000</td>
                                  </tr>
                                  <tr>
                                      <td colspan="2">
                                          <h6 class="m-0 text-end">Sub Total:</h6>
                                      </td>
                                      <td>
                                          210 000
                                      </td>
                                  </tr>

                                  <tr>
                                      <td colspan="2">
                                          <h6 class="m-0 text-end">Total:</h6>
                                      </td>
                                      <td>
                                          210 000
                                      </td>
                                  </tr>
                              </tbody>
                          </table>

                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- end row -->


  </div>

</div>



